module.exports = __webpack_public_path__ + "img/x-octagon-fill.2c517845.svg";